import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IErrorsFilterFormMeta {
    unknown1: FormInputMeta;
    unknown2: FormInputMeta;
    module: FormInputMeta;
    select: FormInputMeta;

    schema: any;
}

const ErrorsFilterFormMeta = {} as IErrorsFilterFormMeta;

ErrorsFilterFormMeta.unknown1 = {
    name: "unknown1",
    type: "text",
    label: "_",
    placeholder: "",
    validation: yup.string(),
};

ErrorsFilterFormMeta.unknown2 = {
    name: "unknown2",
    type: "text",
    label: "_",
    placeholder: "",
    validation: yup.string(),
};

ErrorsFilterFormMeta.module = {
    name: "module",
    type: "text",
    label: "Module",
    placeholder: "Module",
    validation: yup.string(),
};

ErrorsFilterFormMeta.select = {
    name: "select",
    type: "select",
    label: "_",
    placeholder: "",
    validation: yup.string(),
};

ErrorsFilterFormMeta.schema = yup.object().shape(getValidationSchema(ErrorsFilterFormMeta));

export default ErrorsFilterFormMeta;